import React, { useState, useRef, useEffect } from 'react';
import { X, ChevronDown } from 'lucide-react';

const MultiSelectCombobox = ({ options, selectedOptions, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const comboboxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (comboboxRef.current && !comboboxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    if (!selectedOptions.find(o => o.id === option.id)) {
      onChange([...selectedOptions, option]);
    }
    setIsOpen(false);
  };

  const handleDeselect = (option) => {
    onChange(selectedOptions.filter(o => o.id !== option.id));
  };

  const availableOptions = options.filter(opt => !selectedOptions.some(sel => sel.id === opt.id));

  return (
    <div ref={comboboxRef} className="relative w-full">
      <div 
        className="flex flex-wrap items-center gap-2 p-2 min-h-[40px] bg-white border border-gray-300 rounded-md shadow-sm cursor-text"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedOptions.length > 0 ? (
          selectedOptions.map(option => (
            <span key={option.id} className="flex items-center gap-1.5 bg-indigo-100 text-indigo-700 text-sm font-medium px-2 py-1 rounded-full">
              {option.name}
              <button 
                onClick={(e) => { e.stopPropagation(); handleDeselect(option); }}
                className="text-indigo-500 hover:text-indigo-800"
              >
                <X size={14} />
              </button>
            </span>
          ))
        ) : (
          <span className="text-gray-500 px-2">{placeholder}</span>
        )}
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <ChevronDown className={`h-5 w-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </div>
      </div>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
          <ul className="py-1">
            {availableOptions.length > 0 ? (
              availableOptions.map(option => (
                <li 
                  key={option.id} 
                  onClick={() => handleSelect(option)}
                  className="px-4 py-2 text-gray-700 hover:bg-indigo-50 cursor-pointer"
                >
                  {option.name}
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-gray-500">すべてのカテゴリを選択済みです</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultiSelectCombobox;
